module.exports = __webpack_public_path__ + "img/zhibu.29c21dfb.png";